/*
 * Copyright (c) CJSC PETER-SERVICE, 2023.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Andrey Dubov
 * @author Ilya Babanov
 * @author Ilya Baranchikov
 * @version 8.13.0
 * @since 1.0.0
 */

/**
 * Colors palette
 */
export const BrandColorMain = '#00b956';
export const BrandColorMainLighter = '#ebf9f1';
export const BrandColorMainHover = '#10e272';
export const BrandColorMainDarken = '#01873f';
export const BrandColorMainLighten = '#14cd6a';

export const ColorError = '#f62434';
export const ColorWarning = '#ffa717';
export const ColorLink = '#34aaf2';
export const ColorGreenDark = '#404d46';
export const ColorGreenLight = '#59ffa7';

export const ColorGrey1 = '#333333';
export const ColorGrey2 = '#404d46';
export const ColorGrey3 = '#b2b2b2';
export const ColorGrey4 = '#f6f6f6';
export const ColorGrey5 = '#fafafa';
export const ColorGrey6 = '#f9f9f9';
export const ColorGrey7 = '#ccc';
export const ColorGreyLight1 = '#d8d8d8';
export const ColorGreyLight2 = '#ededed';
export const ColorWhite = '#ffffff';

export const _137C = '#ffa717';
export const _311C = '#5bd9e5';
export const Aquamarine = '#08d6a1';
export const Azure = '#00a2ff';
export const BlueBlue = '#1c53cd';
export const SoftBlue = '#6CC7ff';
export const ButtonDown = '#404d46';
export const LightSoftGreen = '#ddffec';
export const ButtonHoverGreen = '#10e272';
export const ButtonHoverPurple = '#a500bf';
export const ClearWhite = '#ffffff';
export const DarkPeach = '#d79159';
export const FreshAsphalt = '#333333';
export const FreshAsphalt50 = 'rgba(51, 51, 51, 0.5)';
export const FullBlack = '#000000';
export const Fury = '#f62434';
export const LightFury = '#f8505d';
export const Green = '#00b956';
export const Link = '#34aaf2';
export const NiceBlue = '#128ab2';
export const LightBlue = '#e1faff';
export const Purple = '#731982';
export const LightPurple = '#ffeeff';
export const PurplePink = '#ac31c1';
export const BrandPurple = '#aa67c1';
export const PurpleRed = '#5b1168';
export const PurpleLight = '#821e93';
export const ReflexBlue = '#444189';
export const Salmon = '#ff6d6d';
export const SpbSky0 = '#f6f6f6';
export const SpbSky050 = '#fbfbfb';
export const SpbSky1 = '#ededed';
export const SpbSky150 = '#f6f6f6';
export const SpbSky2 = '#d8d8d8';
export const SpbSky3 = '#999999';
export const SunflowerYellow = '#ffd700';
export const Tangerine = '#ff8800';
export const WarmPink = '#ef476f';
export const WarmRedC = '#eb5a40';

/**
 * Border color
 */
export const borderColorDisabled = ColorGreyLight2;
export const borderColorDown = ColorGrey2;
export const borderColorError = ColorError;
export const borderColorHover = BrandColorMainHover;
export const borderColorLight = ColorGreyLight1;
export const borderColorNormal = ColorGrey1;
export const borderColorSeparate = '#E5E5E5';
export const borderColorSeparateLight = ColorGrey6;
export const borderColorSuccess = BrandColorMain;
export const borderColorWarning = ColorWarning;

/**
 * Background color
 */
export const backgroundColorBlack = FullBlack;
export const backgroundColorDisabled = ColorGreyLight2;
export const backgroundColorDisabledDark = ColorGreyLight1;
export const backgroundColorDown = ColorGrey2;
export const backgroundColorError = ColorError;
export const backgroundColorHover = BrandColorMainHover;
export const backgroundColorHoverGreen = ButtonHoverGreen;
export const backgroundColorHoverNormal = ColorGreyLight2;
export const backgroundColorHoverOpacity = SpbSky150;
export const backgroundColorModal = ColorGrey4;
export const backgroundColorNormal = ColorGrey1;
export const backgroundColorSuccess = BrandColorMain;
export const backgroundColorSuccessLighter = BrandColorMainLighter;
export const backgroundColorWarning = ColorWarning;
export const backgroundColorWhite = ColorWhite;
export const backgroundColorNoticeInfo = LightBlue;
export const backgroundColorGradientStart = BrandColorMainDarken;
export const backgroundColorGradientMiddle = BrandColorMain;
export const backgroundColorGradientEnd = BrandColorMainLighten;

/**
 * Text color
 */
export const textAuthCollapseColor = FreshAsphalt;
export const textColor = ColorGrey1;
export const textColorActive = ColorGrey1;
export const textColorDanger = ColorError;
export const textColorOpacity = FreshAsphalt50;
export const textColorSuccess = BrandColorMain;
export const textColorWarning = WarmRedC;
export const textColorWhite = ColorWhite;
export const textDisabledColor = ColorGrey1;
export const textFocusColor = ColorGrey1;
export const textLabelColor = ColorGrey1;
export const textLinkColor = ColorLink;

export default {
    backgroundColorBlack,
    backgroundColorDisabled,
    backgroundColorDisabledDark,
    backgroundColorDown,
    backgroundColorError,
    backgroundColorHover,
    backgroundColorHoverGreen,
    backgroundColorHoverNormal,
    backgroundColorHoverOpacity,
    backgroundColorModal,
    backgroundColorNormal,
    backgroundColorNoticeInfo,
    backgroundColorSuccess,
    backgroundColorSuccessLighter,
    backgroundColorWarning,
    backgroundColorWhite,
    backgroundColorGradientStart,
    backgroundColorGradientMiddle,
    backgroundColorGradientEnd,
    borderColorDisabled,
    borderColorDown,
    borderColorError,
    borderColorHover,
    borderColorLight,
    borderColorNormal,
    borderColorSeparate,
    borderColorSeparateLight,
    borderColorSuccess,
    borderColorWarning,
    textAuthCollapseColor,
    textColor,
    textColorActive,
    textColorDanger,
    textColorOpacity,
    textColorSuccess,
    textColorWarning,
    textColorWhite,
    textDisabledColor,
    textFocusColor,
    textLabelColor,
    textLinkColor,
};
